import { useState } from "react";
import { Location, useLocation } from "react-router";

import { useCreateZKCertMutation } from "shared/api/use-create-zk-cert-mutation";

import { CertificateStep } from "../types";
import { CertificateGenerationContent } from "./certificate-generation-content";
import { GenerationSuccessContent } from "./generation-success-content";

type Props = {
  encryptionPubKey: string;
  from: string;
  holderCommitment: string;
};

const getProvider = (location: Location) => {
  if (location.pathname.includes("uniswap")) {
    return "uniswap";
  } else if (location.pathname.includes("binance")) {
    return "binance";
  } else {
    return "twitter";
  }
};

export const GenerateCertificateContent = ({
  encryptionPubKey,
  holderCommitment,
  from,
}: Props) => {
  const location = useLocation();

  const [step, setStep] = useState<CertificateStep>("idle");
  const [certificate, setCertificate] = useState("");
  const [errMsg, setErrMsg] = useState("");

  const provider = getProvider(location);

  const createMutation = useCreateZKCertMutation({
    onSuccess: async (data, variables) => {
      console.log("onSuccess", data);
      if (!data.certificate) {
        setTimeout(() => {
          createMutation.mutate(variables);
        }, 5000);
        return;
      }

      setCertificate(data.certificate);
      setStep("download");
    },
    onError: (err) => {
      setStep("fail");
      console.error(err);
      if (
        typeof err === "object" &&
        err &&
        "message" in err &&
        typeof err.message === "string"
      ) {
        setErrMsg(err.message);
      }
    },
  });

  const handleStartGenerate = () => {
    setStep("generation");
    createMutation.mutate({ encryptionPubKey, holderCommitment, provider });
  };

  return (
    <>
      {step === "generation" || step === "idle" ? (
        <CertificateGenerationContent
          step={step}
          provider={provider}
          onStartGenerate={handleStartGenerate}
        />
      ) : null}
      {step === "download" && (
        <GenerationSuccessContent
          certificate={certificate}
          from={from}
          provider={provider}
          onError={(err) => {
            if (err instanceof Error) setErrMsg(err.message);
            console.error(err);
          }}
        />
      )}
      {step === "fail" && <div>{errMsg}</div>}
    </>
  );
};
